import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	defaultCopyMessage: {
		id: 'eoc.copy-to-clipboard.default.copy.no-translate',
		defaultMessage: 'Copy to clipboard',
		description: 'Text will be displayed as tooltip on the copy icon if none provided',
	},
	copiedMessage: {
		id: 'eoc.copy-to-clipboard.copied.no-translate',
		defaultMessage: 'Copied!',
		description: 'Text will be displayed as tooltip after copy is clicked',
	},
});

export default messages;
